define('common/ko/fn/split',['knockout', 'underscore', 'common/tools'], function(ko, _, tools) {
    ko.subscribable.fn.split = _.memoize(function(splitter) {
        var self = this;
        return ko.pureComputedArray(function() {
            var value = _.trim(self());
            if (_.str.isBlank(value)) {
                return [];
            }
            return _.reduce(value.split(splitter), function(memo, id) {
                memo.push(_.trim(id));
                return memo;
            }, []);
        });
    }, function(splitter) { return tools.objToHash([this, splitter]); } );
});

